var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66663 1.5C3.62906 1.5 1.16663 3.96243 1.16663 7C1.16663 10.0376 3.62906 12.5 6.66663 12.5C9.70419 12.5 12.1666 10.0376 12.1666 7C12.1666 3.96243 9.70419 1.5 6.66663 1.5ZM0.166626 7C0.166626 3.41015 3.07677 0.5 6.66663 0.5C10.2565 0.5 13.1666 3.41015 13.1666 7C13.1666 10.5899 10.2565 13.5 6.66663 13.5C3.07677 13.5 0.166626 10.5899 0.166626 7Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66663 6.5C5.66663 6.22386 5.89048 6 6.16663 6H6.66663C6.94277 6 7.16663 6.22386 7.16663 6.5V9.5C7.44277 9.5 7.66663 9.72386 7.66663 10C7.66663 10.2761 7.44277 10.5 7.16663 10.5H6.66663C6.39048 10.5 6.16663 10.2761 6.16663 10V7C5.89048 7 5.66663 6.77614 5.66663 6.5Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41663 5C6.83084 5 7.16663 4.66421 7.16663 4.25C7.16663 3.83579 6.83084 3.5 6.41663 3.5C6.00241 3.5 5.66663 3.83579 5.66663 4.25C5.66663 4.66421 6.00241 5 6.41663 5Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSm);
export default __webpack_public_path__ + "static/media/infoSm.567cd3162f82dfea0e8ee6741754eb26.svg";
export { ForwardRef as ReactComponent };